module.exports = __webpack_public_path__ + "img/fdj.50835231.png";